<template>
	<div :id="blok._uid" class="mx-sm space-y-md md:mx-md 2xl:mx-0">
		<div
			class="flex flex-col gap-sm space-y-lg md:grid md:grid-cols-3 md:space-y-0"
		>
			<v-storyblok-article-recommended
				v-for="(article, index) in articles"
				:key="index"
				:blok="article"
				:article="article.uuid"
			/>
		</div>

		<div class="flex items-center justify-center">
			<nuxt-link
				v-if="url !== undefined"
				:to="
					blok.button_link.url
						? '/' + blok.button_link.url
						: '/' + blok.button_link.cached_url
				"
				:aria-label="blok.button_text"
				class="mx-auto mt-xl w-full text-center"
			>
				<v-button
					:aria-label="blok.button_text"
					size="base"
					theme="black"
					class="w-auto"
				>
					{{ blok.button_text }}
				</v-button>
			</nuxt-link>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {BaseBlokComponent} from "@pkg/shared/types";

import {useStoryblokStoriesList} from "@pkg/shared/composables/use-storyblok-stories-list";
import formatSbUrl from "@pkg/shared/utils/format-sb-url";

const properties = defineProps<{
	blok: BaseBlokComponent;
}>();

const articleUuids = properties.blok.articles?.join(",");

const url = computed(() => formatSbUrl(properties.blok.button_link));

const {
	data: {value: articles},
} = await useStoryblokStoriesList("articles-feed-pages", {
	by_uuids: articleUuids,
	is_startpage: false,
	per_page: 6,
	sort_by: "first_published_at:desc",
});
</script>
